// extracted by mini-css-extract-plugin
export default {"item":"Seat_item__NQLqm","item_selected":"Seat_item_selected__UYCqY"};